module.exports = __webpack_public_path__ + "img/69_24.5479c8c5.png";